import React, { useEffect } from 'react';

const Palestra = () => {
  useEffect(() => {
    document.title = 'Palestra - ConLicitantes';
  }, []);

  return (
    <div className="page-container pt-5 text-center">
      <h1>Excesso de discricionariedade da Administração Pública</h1>
      <div>
        <iframe
          title="Ia ConLicitação"
          id="video"
          width="80%"
          height="600"
          src="https://player.vimeo.com/video/1132501712"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};
export default Palestra;
